import React from "react";
import { Trans } from "react-i18next";

export const HeaderData = ({ label, value, invoiceLabelStyle, invoiceContentStyle, ...props }) =>
  !!value ? (
    <div {...props}>
      <strong style={invoiceLabelStyle || {}}>
        <Trans>{label}</Trans>
      </strong>
      <br />
      <div style={{wordWrap:"break-word", ...invoiceContentStyle || {}}}>{value}</div>
    </div>
  ) : null;

export default HeaderData;
